module.exports = __webpack_public_path__ + "img/1602779109TAT_Group.b6e04553.svg";